import Model from '@models/Model'
import Country from '@models/Country'
import TrainingCenter from '@models/TrainingCenter'

class PersonRole extends Model {
  constructor (initialData, included) {
    super(initialData, included, {
      columns: [
        'id',
        'person_id',
        'relatable_type',
        'relatable_id',
        'role',
        'state',
        'discarded_at',
        'effective_at',
        'ineffective_at',
        'estimated_effective_at',
        'estimated_ineffective_at',
        'current_for_relatable',
        'ineffective_reason',
        'training_center_batch_id',
        'created_at',
        'updated_at',
      ],
      dateKeys: [
        'discarded_at',
        'effective_at',
        'ineffective_at',
        'estimated_effective_at',
        'estimated_ineffective_at',
        'created_at',
        'updated_at',
      ],
      relationships: {
        relatable: { collection: false, polymorphic: { country: Country, 'training_center': TrainingCenter } },
      },
    })
  }
}

export default PersonRole
